/*
 * @Author: zhangcongcong zhangcongcong@move2newidea.com
 * @Date: 2023-08-11 17:57:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-29 14:50:24
 * @FilePath: /memo-web/src/pages/view/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useEffect, useState, useRef } from 'react'
import { StorageModule } from '../../modules/storage';
import { userModule } from '../../modules/user';
import { PlusOutlined, } from '@ant-design/icons';

import * as apis from '../../api/user'
import * as apis2 from '../../api/networkDisk'
import type { MenuProps } from 'antd';
import useStore from '../../store/useStore'

import LevelView from '../../components/level/index';

interface Props {
    history: any;
}

const View = (props: Props) => {
    const { store, dispatch } = useStore();
    const [levelData, setLevelData] = useState<any>(null);

    useEffect(() => {
        // init()
    }, [])
    const init = async () => {
        const res: any = await apis.hierarchy_view(store.subjectInfo.subjectId);
        if (res.ok) {
            setLevelData(res.data)
            dispatch({
                type: 'SET_VIEW_HIERARCHY_INFO',
                data: { ...store.viewHierarchyInfo, hierarchyMax: res.data?.hierarchyMax || 0 }
            });
        }

    }
    return (
        <div className='' style={{ background: '#EFF3F3', overflow: "auto", position: "relative" }}>
            <div style={{ height: '40px'}}> </div>
            <LevelView treeData={levelData?.memos} params={
                {
                    users: levelData?.users,
                    data: levelData,
                    viewHierarchyInfo: levelData?.viewHierarchyInfo,
                    memoId: levelData?.memoId,
                    subjectId: levelData?.id
                }
            } onRefresh={() => { init() }} />

        </div>
    )
}

export default View
